import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from '@reduxjs/toolkit';

import * as api from '../../app/api';

export const createSkuProducts = createAsyncThunk(
  'skuProducts/createSkuProducts',
  async (body, { getState, requestId }) => {
    const { currentRequestId, loading } = getState().skuProducts;

    if (loading !== 'pending' || requestId !== currentRequestId) {
      return;
    }

    try {
      const data = await api.createProduct(body);

      return data.data;
    } catch (e) {
      throw new Error(e.response?.data?.reason);
    }
  }
);

export const fetchListSkuProducts = createAsyncThunk(
  'skuProducts/fetchListSkuProducts',
  async ({ skuId, params }) => {
    try {
      const p = { limit: 20, offset: (params.page - 1) * 20 };
      const data = await api.fetchListSkuProducts(skuId, p);

      return data;
    } catch (e) {
      throw new Error(e.response?.data?.reason);
    }
  }
);

const skuProductsAdapter = createEntityAdapter({
  selectId: (entity) => entity.productId,
});

const skuProductsSlice = createSlice({
  initialState: skuProductsAdapter.getInitialState({
    total: 0,
    loading: 'idle',
    currentRequestId: undefined,
    error: null,
  }),
  name: 'skuProducts',
  reducers: {},
  extraReducers: {
    [createSkuProducts.pending]: (state, { meta }) => {
      if (state.loading === 'idle') {
        state.currentRequestId = meta.requestId;
        state.error = null;
        state.loading = 'pending';
      }
    },
    [createSkuProducts.fulfilled]: (state, { meta, payload }) => {
      if (
        state.loading === 'pending' &&
        state.currentRequestId === meta.requestId
      ) {
        state.currentRequestId = undefined;
        state.loading = 'idle';
        state.total = state.total + payload.length;

        skuProductsAdapter.addMany(state, payload);
      }
    },
    [createSkuProducts.rejected]: (state, { meta, error }) => {
      if (
        state.loading === 'pending' &&
        state.currentRequestId === meta.requestId
      ) {
        state.currentRequestId = undefined;
        state.error = error;
        state.loading = 'idle';
      }
    },
    [fetchListSkuProducts.pending]: (state, { meta }) => {
      if (state.loading === 'idle') {
        state.currentRequestId = meta.requestId;
        state.loading = 'pending';
      }
    },
    [fetchListSkuProducts.fulfilled]: (state, { meta, payload }) => {
      if (
        state.loading === 'pending' &&
        state.currentRequestId === meta.requestId
      ) {
        state.currentRequestId = undefined;
        state.loading = 'idle';
        state.total = payload.total;

        skuProductsAdapter.setAll(state, payload.data);
      }
    },
    [fetchListSkuProducts.rejected]: (state, { meta, error }) => {
      if (
        state.loading === 'pending' &&
        state.currentRequestId === meta.requestId
      ) {
        state.currentRequestId = undefined;
        state.error = error;
        state.loading = 'idle';
      }
    },
  },
});

export const selectSkuProductsEntity = (state) => ({
  ids: state.skuProducts.ids,
  entities: state.skuProducts.entities,
  total: state.skuProducts.total,
});

export default skuProductsSlice.reducer;
